<div class="modal__content">
    <div class="uploading-popup-header">
        <span>{{message}}</span>
    </div>
    <div class="uploading-popup-text">
        <div class="loader__container">
	        <div class="loader"></div>
	    </div>
    </div>
</div>